// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"ed9add34","239":"7172428c","455":"881efa69"}[chunkId] + ".chunk.js";
};